module.exports = "/images/wm-team-ann.6128eecb83153c9c4209b7173ef95bc6.png";